import {
  FacebookIcon,
  LinkedInIcon,
  TwitterIcon,
  YouTubeIcon,
  TelegramIcon,
  InstagramIcon,
  RssIcon,
  IgTvIcon, VkIcon
} from './icon'

const SOCIAL_MEDIA_LIST = [
  {
    mediaType: 'facebook',
    icon: FacebookIcon(),
    title: 'Facebook'
  },
  {
    mediaType: 'linkedIn',
    icon: LinkedInIcon(),
    title: 'LinkedIn'
  },
  {
    mediaType: 'twitter',
    icon: TwitterIcon(),
    title: 'Twitter'
  },
  {
    mediaType: 'youTube',
    icon: YouTubeIcon(),
    title: 'YouTube'
  },
  {
    mediaType: 'telegram',
    icon: TelegramIcon(),
    title: 'Telegram'
  },
  {
    mediaType: 'instagram',
    icon: InstagramIcon(),
    title: 'Instagram'
  },
  {
    mediaType: 'rss',
    icon: RssIcon(),
    title: 'RSS'
  },
  {
    mediaType: 'igtv',
    icon: IgTvIcon(),
    title: 'IGTV'
  },
  {
    mediaType: 'vkontakte',
    icon: VkIcon(),
    title: 'Vkontakte'
  }
]

export default SOCIAL_MEDIA_LIST



// WEBPACK FOOTER //
// ./src/constants/socialMedia.js